import React, {useEffect, useState} from "react";
import DOMPurify from 'dompurify';

function ArticlePage(props){
	const [articleHtml, setArticleHtml] = useState();
	useEffect(() => {
		fetch('/help/'+props.articleUrl+'.html')
		.then(res => {
			res.text().then(text=>setArticleHtml({__html:DOMPurify.sanitize(text)}));
		})
	}, [])

	return (<div dangerouslySetInnerHTML={articleHtml} ></div>);
}
export default ArticlePage;